import { render, staticRenderFns } from "./trip-info.vue?vue&type=template&id=fd8a1d40&scoped=true"
import script from "./trip-info.vue?vue&type=script&lang=js"
export * from "./trip-info.vue?vue&type=script&lang=js"
import style0 from "./trip-info.vue?vue&type=style&index=0&id=fd8a1d40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8a1d40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd8a1d40')) {
      api.createRecord('fd8a1d40', component.options)
    } else {
      api.reload('fd8a1d40', component.options)
    }
    module.hot.accept("./trip-info.vue?vue&type=template&id=fd8a1d40&scoped=true", function () {
      api.rerender('fd8a1d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/intercity/components/trip-info.vue"
export default component.exports